export default {"src":"/_next/static/media/zip.00bb65f8.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};